<template>
    <div class="saas-page engagement-page linear-command-page">
        <div class="saas-hero card-saas engagement-page__hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('subscriber.subscriber') }}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('subscriber.subscriber')}}</h1>
            </div>
            <div class="engagement-page__actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders"></admin-icon> <span>{{trans('general.filter')}}</span>
                </button>
            </div>
        </div>

        <div class="engagement-command-grid">
            <section class="engagement-command-card">
                <span>{{ trans('subscriber.subscriber') }}</span>
                <strong>{{ subscribers.total || 0 }}</strong>
                <p>{{ subscribers.total ? trans('general.total_result_found',{'count' : subscribers.total}) : trans('general.no_result_found') }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('general.filter') }}</span>
                <strong>{{ filterSubscriberForm.sort_by }}</strong>
                <p>{{ trans('general.order') }}: {{ filterSubscriberForm.order }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('subscriber.status') }}</span>
                <strong>{{ filterSubscriberForm.status === '' ? trans('general.select_one') : (filterSubscriberForm.status == 1 ? trans('subscriber.subscribed') : trans('subscriber.unsubscribed')) }}</strong>
                <p>{{ trans('general.date_between') }}</p>
            </section>
        </div>
        
        <transition name="fade">
            <div class="card-saas engagement-filter-card" v-if="showFilterPanel">
                <div class="card-body">
                    <h4 class="card-saas__title">{{trans('general.filter')}}</h4>
                    <div class="row">
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('subscriber.email')}}</label>
                                <input class="form-control" name="email" v-model="filterSubscriberForm.email">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('subscriber.status')}}</label>
                                <select name="status" class="form-control" v-model="filterSubscriberForm.status">
                                    <option value="">{{trans('general.select_one')}}</option>
                                    <option value=1>{{trans('subscriber.subscribed')}}</option>
                                    <option value=0>{{trans('subscriber.unsubscribed')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <date-range-picker :start-date.sync="filterSubscriberForm.start_date" :end-date.sync="filterSubscriberForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.sort_by')}}</label>
                                <select name="order" class="form-control" v-model="filterSubscriberForm.sort_by">
                                    <option value="email">{{trans('subscriber.email')}}</option>
                                    <option value="created_at">{{trans('subscriber.created_at')}}</option>
                                    <option value="status">{{trans('subscriber.status')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.order')}}</label>
                                <select name="order" class="form-control" v-model="filterSubscriberForm.order">
                                    <option value="asc">{{trans('general.ascending')}}</option>
                                    <option value="desc">{{trans('general.descending')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        
        <div class="admin-list-table-card mt-3" v-if="hasPermission('list-subscriber') && subscribers.total">
            <div class="table-responsive">
                <table class="table admin-data-table mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="email" :sort-by="filterSubscriberForm.sort_by" :order="filterSubscriberForm.order" @sort="sortList">{{trans('subscriber.email')}}</sortable-th>
                            <sortable-th field="status" :sort-by="filterSubscriberForm.sort_by" :order="filterSubscriberForm.order" @sort="sortList">{{trans('subscriber.status')}}</sortable-th>
                            <th>{{trans('subscriber.ip')}}</th>
                            <th>{{trans('subscriber.user_agent')}}</th>
                            <sortable-th field="created_at" :sort-by="filterSubscriberForm.sort_by" :order="filterSubscriberForm.order" @sort="sortList">{{trans('subscriber.created_at')}}</sortable-th>
                            <th>{{trans('subscriber.updated_at')}}</th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="subscriber in subscribers.data" :key="subscriber.id">
                            <td>
                                <span class="engagement-table__primary" v-text="subscriber.email"></span>
                                <span class="engagement-table__meta">#{{ subscriber.id }}</span>
                            </td>
                            <td v-html="getStatus(subscriber)"></td>
                            <td v-text="subscriber.ip"></td>
                            <td><span class="engagement-table__muted" v-text="subscriber.user_agent"></span></td>
                            <td><span class="engagement-table__muted">{{subscriber.created_at | moment }}</span></td>
                            <td><span class="engagement-table__muted">{{subscriber.updated_at | moment }}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('edit-subscriber')"
                                        @click="updateStatus(subscriber)"
                                    >
                                        <admin-icon :name="subscriber.status ? 'x-circle' : 'check-circle'"></admin-icon>
                                        {{ trans('subscriber.'+(subscriber.status ? 'unsubscribe' : 'subscribe')) }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-subscriber')"
                                        v-confirm="{ok: confirmDelete(subscriber)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterSubscriberForm.page_length" :records="subscribers" @updateRecords="getSubscribers" @change.native="getSubscribers"></pagination-record>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-3" v-if="!subscribers.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="mail"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
            </div>
        </div>
    </div>
</template>
<script>
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components: {dateRangePicker},
        data(){
            return {
                subscribers: {
                    total: 0,
                    data: []
                },
                filterSubscriberForm: {
                    email: '',
                    status: '',
                    start_date: '',
                    end_date: '',
                    order: 'desc',
                    sort_by: 'created_at',
                    page_length: helper.getConfig('page_length')
                },
                showFilterPanel: false
            };
        },
        mounted(){
            this.getSubscribers();
        },
        methods: {
            getSubscribers(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterSubscriberForm);
                axios.get('/api/subscriber?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.subscribers = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(subscriber){
                return dialog => this.deleteQuery(subscriber);
            },
            deleteQuery(subscriber){
                axios.delete('/api/subscriber/'+subscriber.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getSubscribers();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getStatus(subscriber){
                if(subscriber.status)
                    return '<span class="admin-status-badge admin-status-badge--success">'+i18n.subscriber.subscribed+'</span>';
                else if(! subscriber.status)
                    return '<span class="admin-status-badge admin-status-badge--danger">'+i18n.subscriber.unsubscribed+'</span>';
            },
            updateStatus(subscriber){
                axios.patch('/api/subscriber/'+subscriber.id).then(response => response.data)
                .then(response => {
                    this.getSubscribers();
                    toastr.success(response.message);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            sortList(field){
                if (this.filterSubscriberForm.sort_by === field) {
                    this.filterSubscriberForm.order = this.filterSubscriberForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterSubscriberForm.sort_by = field;
                    this.filterSubscriberForm.order = 'asc';
                }
            }
        },
        filters: {
          moment(date) {
            return helper.formatDateTime(date);
          }
        },
        watch: {
            filterSubscriberForm: {
                handler(val){
                    this.getSubscribers();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
.linear-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7ef;
    --linear-muted: #687083;
    --linear-ink: #111318;
}

.engagement-page__hero {
    align-items: center;
    border-color: rgba(98, 92, 246, 0.14);
    background:
        radial-gradient(circle at top right, rgba(98, 92, 246, 0.13), transparent 28rem),
        rgba(255, 255, 255, 0.94);
}

.engagement-page__actions {
    display: flex;
    justify-content: flex-end;
}

.engagement-command-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.9rem;
    margin: 1rem 0;
}

.engagement-command-card {
    min-height: 112px;
    padding: 1rem;
    border: 1px solid var(--linear-line);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 16px 42px rgba(31, 35, 48, 0.055);
}

.engagement-command-card--muted {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%);
}

.engagement-command-card span {
    color: var(--linear-accent);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.engagement-command-card strong {
    display: block;
    margin-top: 0.45rem;
    color: var(--linear-ink);
    font-size: 1.45rem;
    font-weight: 800;
    letter-spacing: -0.04em;
}

.engagement-command-card p {
    margin: 0.35rem 0 0;
    color: var(--linear-muted);
    line-height: 1.45;
}

.engagement-filter-card {
    padding: 0;
    overflow: hidden;
}

.engagement-filter-card .card-body {
    padding: 1rem 1.15rem;
}

.engagement-table__primary {
    color: #0f172a;
    font-weight: 700;
}

.engagement-table__meta {
    display: block;
    margin-top: 0.15rem;
    color: #94a3b8;
    font-size: 0.75rem;
    font-weight: 700;
}

.engagement-table__muted {
    color: #64748b;
}

@media (max-width: 575.98px) {
    .engagement-page__hero {
        align-items: flex-start;
    }

    .engagement-page__actions {
        justify-content: flex-start;
        width: 100%;
    }
}

@media (max-width: 991.98px) {
    .engagement-command-grid {
        grid-template-columns: 1fr;
    }
}
</style>
